export enum ContractStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Inactive = 'INACTIVE',
  InTermination = 'IN_TERMINATION',
}
